package com.rajen.angrejidictionary.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SuggestionDeviceInfo(
    @SerialName("platform") val platform: String,
    @SerialName("device_model") val deviceModel: String? = null,
    @SerialName("manufacturer") val manufacturer: String? = null,
    @SerialName("os_version") val osVersion: String? = null,
    @SerialName("language") val language: String? = null,
    @SerialName("screen_size") val screenSize: String? = null
)

@Serializable
data class SuggestionAppVersion(
    @SerialName("version_name") val versionName: String,
    @SerialName("version_code") val versionCode: Long
)

@Serializable
data class SuggestionItem(
    val id: String,
    @SerialName("suggested_word") val suggestedWord: String,
    @SerialName("user_note") val userNote: String? = null,
    @SerialName("device_info") val deviceInfo: SuggestionDeviceInfo,
    @SerialName("app_version") val appVersion: SuggestionAppVersion,
    val status: String,
    @SerialName("created_at") val createdAt: Long,
    @SerialName("reviewed_at") val reviewedAt: Long? = null,
    @SerialName("reviewed_by") val reviewedBy: String? = null,
    // Whether this suggestion has an fcm_token attached, so approving it will
    // trigger a one-to-one push to the submitter. Live on the backend as of
    // the FCM rollout — the "no push token" banner in SuggestionsTab keys
    // directly off this. Default false is just a safe fallback for
    // ignoreUnknownKeys/lenient parsing, not an expectation the field is missing.
    @SerialName("has_fcm_token") val hasFcmToken: Boolean = false,
    // The raw device token itself, if the backend chooses to return it.
    // NOTE: the backend team's original proposal was to expose only
    // `has_fcm_token` and deliberately withhold the raw token — this field
    // is here because it was explicitly requested, but it requires a
    // corresponding backend change to populate `fcm_token` on
    // SuggestionResponse. Defaults to null, so the UI falls back to the
    // `hasFcmToken` indicator until/unless the backend adds this.
    @SerialName("fcm_token") val fcmToken: String? = null
)

@Serializable
data class SuggestionListData(
    val suggestions: List<SuggestionItem>,
    val total: Long,
    val page: Int,
    val pageSize: Int
)